export const REQUEST_CREATE = 'REQUEST/CREATE';
export const REQUEST_SUCCESS = 'REQUEST/SUCCESS';
export const REQUEST_SUCCESS_MULTIPLE = 'REQUEST/SUCCESS/MULTIPLE';
export const REQUEST_FAILURE = 'REQUEST/FAILURE';
export const REQUEST_FAILURE_MULTIPLE = 'REQUEST/FAILURE/MULTIPLE';
export const REQUEST_DELETE = 'REQUEST/DELETE';
export const REQUEST_DELETE_MULTIPLE = 'REQUEST/DELETE_MULTIPLE';
